export function removeFromArray(index, items) {
  return items.slice(0, index).concat(items.slice(index + 1));
}

export function updateItemInArray(index, item, items) {
  return items
    .slice(0, index)
    .concat(item)
    .concat(items.slice(index + 1));
}



// WEBPACK FOOTER //
// ./src/utils/helpers/immutable.js